import { render, staticRenderFns } from "./WardOrganization.vue?vue&type=template&id=492a670d&scoped=true&"
import script from "./WardOrganization.vue?vue&type=script&lang=js&"
export * from "./WardOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a670d",
  null
  
)

export default component.exports